
export default {
  name: "HeroSection",
};
